import Vue from 'vue'
import store from './store'

import router from './router'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/ko';
import locale from 'element-ui/lib/locale';
import Webzine from "@/App";
import './assets/ckeditor-style.css'

Vue.config.productionTip = false
Vue.use(ElementUI);
locale.use(lang);


Vue.prototype.$successMessage = function (message) {
  this.$message({ message: message, type: 'success' });
};

Vue.prototype.$errorMessage = function (message) {
  this.$message({ message: message, type: 'error' });
};

Vue.prototype.$cmmLoading = function (message) {
  let loadingMsg = '처리 중...';

  if (message) {
    loadingMsg = message;
  }

  return this.$loading({
    lock: true,
    text: loadingMsg,
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  });
};

Vue.prototype.$baseURL = require("./config/webzine.config.json")[process.env.NODE_ENV].VUE_APP_API_SERVER_HOST;
Vue.prototype.$homeURL = require("./config/webzine.config.json")[process.env.NODE_ENV].ROUTER_BASE;
Vue.prototype.$portalUrl = require("./config/webzine.config.json")[process.env.NODE_ENV].PORTAL_BASE;

new Vue({
  router,
  store,
  render: h => h(Webzine)
}).$mount('#webzine')
